
import { Vue, Options } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { PrizeModel } from "../../model/lottery/LotteryModel";
@Options({
  props: {
    toastShow: Boolean
  },
  emits: {
    isshowaction: () => {
      return true;
    }
  }
})
export default class LotteryImageToast extends Vue {
  private dataModel: PrizeModel | null = null;
  mounted() {
    this.getPrizeData();
  }
  getPrizeData() {
    Http.get<PrizeModel>(Urls.lottery_luckyValueAward).then(
      (res: PrizeModel) => {
        this.dataModel = res;
      },
      (err: ResponseData) => {
        console.log("LotteryImageToast:", err.message);
      }
    );
  }
}
